import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';

import store from 'store';
import { addInitConversationInAttendance } from 'store/action/conversation-in-attendance-action';
import { apiChat } from '../../../../http';
import { TabContent } from 'reactstrap';
import { Content, Header } from './components/styled';
import { toast } from 'react-toastify';
import { useConversationConnectionSocketForMonitoring } from 'hooks/useConversationConnectionSocketForMonitoring';
import {
  EVENTS_EMIT,
  useSocketConversationChatTs
} from '../../../../hooks/useSocketConversationChatTs';

//react virtualized
import 'react-virtualized/styles.css';
import TagClientService from 'views/CRM/Tags/services/TagClientService';

import { useHistory } from 'react-router-dom';
import { useQueueChatPauseContext } from '../../../../hooks/useQueuePauseChatServicePanel';
import { ChatSituations } from '../../../../utils/fuctions/mapSituationChat';
import { FilterBar } from './components/FiltersBar';
import { SearchChat } from './components/searchChats';
import { TabChats } from './components/Tabs';
import { IndividualActiveContact } from './components/ActiveContact';
import { TabAttributedChats } from './components/Lists/TabAttributedChats';
import { TabChatsInAttendance } from './components/Lists/TabInChatsAttendance';
import {
  filterConversation,
  filterss
} from './components/Lists/helpers/filters';
import { useQueueContentChatContext } from '../../../../hooks/useQueueContentChat';
import { getIdClientFromChat } from 'utils/fuctions/getIdClientFromChat';
import { addAnsweredConversation } from 'store/action/answered-conversations-action';
import { removeUnAnsweredConversation } from 'store/action/unanswered-convertations-action';
import { TabChatsInWait } from './components/Lists/TabChatsInWait';
import { removeConversationInAttendance } from 'store/action/conversation-in-attendance-action';

export const TABS = {
  ATTRIBUTED: 'ATTRIBUTED',
  IN_ATTENDANCE: 'IN_ATTENDANCE',
  IN_WAIT: 'IN_WAIT'
};
const QueueContent = () => {
  const {
    sort,
    setSort,
    filters,
    setFilters,
    chatsSaved,
    countChatsInWait,
    setCountChatsInWait,
    countAttributedChats,
    chatsWithResponseAgent,
    countChatsInAttendance,
    setCountAttributedChats,
    setCountChatsInAttendance,
    handlerIndividualChatMetrics,
    chatsAgentWithoutInteractionWarning,
    chatsAgentWithoutInteractionCritical,
    chatsCustomerWithoutInteractionCritical,
    setAllChats,
    getQueuesChat
  } = useQueueContentChatContext();
  const history = useHistory();

  const { queuesChatLoggedValues, currentQueueChatPause, inQueueChatPause } =
    useQueueChatPauseContext();
  const { socketConversation } = useConversationConnectionSocketForMonitoring();
  const { emitEventAnsweredChat, socketChatTS } = useSocketConversationChatTs();
  const newContactInfo = useSelector((state) => state.contactEvents);
  const unAnsweredConversations = useSelector(
    (state) => state.unAnsweredConversation
  );
  const answeredConversations = useSelector(
    (state) => state.answeredConversation
  );

  const systemConfiguration = useSelector((state) => state.systemConfiguration);
  const telephonyServicePanel = useSelector(
    (state) => state.telephonyServicePanel
  );

  const [chatsInAttendance, setChatsInAttendance] = useState(false);
  const [chatsInWait, setChatsInWait] = useState(false);
  const [chatsAssigned, setChatsAssigned] = useState(false);

  const [queues, setQueues] = useState([]);
  const [idNameTags, setIdNameTags] = useState({});
  const [tags, setTags] = useState([]);
  //const [allConversation, setAllConversation] = useState([]);
  const [activeTab, setActiveTab] = useState(TABS.IN_ATTENDANCE);
  const [search, setSearch] = useState('');

  const [selectedConversations, setSelectedConversations] = useState([]);

  const [newContactInfoController, setNewContactInfoController] =
    useState(null);

  const isInAttendance = (chat) => {
    return (
      chat?.atendida &&
      chat?.atendente?.id_postgres === localStorage.getItem('login')
    );
  };

  const answerConversationToast = (id) => {
    const chat = allConversation.find((chat) => chat?.id === id);
    answerConversation(chat, id);
  };
  //Realizar ação ao clicar no card

  const idChatToast = useMemo(() => {
    return history?.location?.state;
  }, [history?.location?.state]);

  useEffect(() => {
    if (idChatToast?.idChat) {
      answerConversationToast(idChatToast?.idChat);
    }
  }, [idChatToast]);

  const handleCheck = (event, id) => {
    if (event.target.checked) {
      setSelectedConversations((prev) => [...prev, id]);
      return;
    }
    const copy = [...selectedConversations];
    const index = copy.findIndex((item) => item === id);
    copy.splice(index, 1);
    setSelectedConversations(copy);
  };

  useEffect(() => {
    if (Object.keys(newContactInfo.contactInfo).length > 0) {
      setNewContactInfoController(newContactInfo.contactInfo);
    }
  }, [newContactInfo]);

  const orderByChatsSaved = (chats, chatsSaved) => {
    if (!chatsSaved || chatsSaved.size === 0) {
      return chats;
    }
    return chats.sort((a, b) => {
      if (chatsSaved?.has(a?.id)) {
        return -1;
      }
      if (chatsSaved?.has(b?.id)) {
        return 1;
      }
      return 0;
    });
  };

  const orderByLastMessage = (chats) => {
    return chats.sort((a, b) => {
      const lastMessageA = a.mensagens
        .filter((message) => message.cliente_ou_atendente === 'cliente')
        .pop();

      const lastMessageB = b.mensagens
        .filter((message) => message.cliente_ou_atendente === 'cliente')
        .pop();

      const dateA =
        new Date().getTime() -
        new Date(lastMessageA?.hora_da_mensagem || 0).getTime();
      const dateB =
        new Date().getTime() -
        new Date(lastMessageB?.hora_da_mensagem || 0).getTime();

      return dateA - dateB;
    });
  };

  const getLastMessage = (messages) => {
    return messages?.find(
      (message) =>
        message?.actions?.action === 'default' ||
        message?.actions?.action === 'answer'
    );
  };

  const orderByMoreTimeInChat = (chats) => {
    const getLastMessageCustomer = (
      messages,
      index,
      lastMessage,
      isInitialSequence
    ) => {
      const nextMessage = messages[index];

      if (!nextMessage) return lastMessage;

      if (nextMessage.cliente_ou_atendente === 'cliente') {
        return getLastMessageCustomer(messages, index - 1, nextMessage, false);
      }

      if (nextMessage.cliente_ou_atendente === 'atendente') {
        if (isInitialSequence)
          return getLastMessageCustomer(messages, index - 1, nextMessage, true);
        else return lastMessage;
      }

      return null;
    };

    return chats
      .sort((a, b) => {
        const lastMessageA = getLastMessage(a?.mensagens);
        const lastMessageB = getLastMessage(b?.mensagens);

        // Verificar se a última mensagem é do atendente
        const isLastMessageFromAgentA =
          lastMessageA?.cliente_ou_atendente === 'atendente';
        const isLastMessageFromAgentB =
          lastMessageB?.cliente_ou_atendente === 'atendente';

        if (isLastMessageFromAgentA && !isLastMessageFromAgentB) return -1;

        if (!isLastMessageFromAgentA && isLastMessageFromAgentB) return 1;

        if (isLastMessageFromAgentA && isLastMessageFromAgentB) return 0;

        const lastClientMessageA = getLastMessageCustomer(
          a?.mensagens,
          a?.mensagens.length - 1,
          null,
          true
        );

        const lastClientMessageB = getLastMessageCustomer(
          b?.mensagens,
          b?.mensagens.length - 1,
          null,
          true
        );

        const dateA =
          new Date().getTime() -
          new Date(lastClientMessageA?.hora_da_mensagem || 0).getTime();
        const dateB =
          new Date().getTime() -
          new Date(lastClientMessageB?.hora_da_mensagem || 0).getTime();

        return dateB - dateA;
      })
      .reverse();
  };

  const orderByMoreTimeInQueue = (chats) => {
    return chats.sort((a, b) => {
      const dateA = new Date(a.hora_criacao).getTime();
      const dateB = new Date(b.hora_criacao).getTime();

      const dateNow = new Date().getTime();

      const differenceA = dateNow - dateA;
      const differenceB = dateNow - dateB;

      return differenceB - differenceA;
    });
  };

  function organizedConversations(chats) {
    let chatsOrder = chats;

    if (sort['CHATS_SAVED']) {
      return orderByChatsSaved(chatsOrder, chatsSaved);
    }

    if (sort['LAST_MESSAGE_CUSTOMER']) {
      return orderByLastMessage(chatsOrder);
    }

    if (sort['MORE_TIME_IN_WAIT']) {
      return orderByMoreTimeInChat(chatsOrder);
    }

    if (sort['MORE_TIME_IN_QUEUE']) {
      return orderByMoreTimeInQueue(chatsOrder);
    }
    return chatsOrder;
  }
  let allConversation = useMemo(() => {
    let internValue = [
      ...answeredConversations.conversations,
      ...unAnsweredConversations.conversations
    ];
    if (internValue) {
      if (newContactInfoController) {
        const allConversationMap = internValue.map((conversation) => {
          if (
            conversation.cliente &&
            getIdClientFromChat(conversation) ===
              newContactInfoController.conversationId
          ) {
            return {
              ...conversation,
              cliente: {
                ...conversation.cliente,
                nome: newContactInfoController.contactName
              }
            };
          }
          return conversation;
        });
        internValue = allConversationMap;
      }

      internValue.forEach((conversation) => {
        if (isInAttendance(conversation)) {
          handlerIndividualChatMetrics(conversation);
        }
      });
    }
    return internValue;
  }, [
    unAnsweredConversations,
    answeredConversations,
    newContactInfoController
  ]);

  useEffect(() => {}, [newContactInfoController]);

  useEffect(() => {
    getQueuesChat()
      .then((response) => {
        let arrayQueues = [];
        const attendantQueues = JSON.parse(localStorage.getItem('queues'));
        response.forEach((queue) => {
          attendantQueues.forEach((attendantQueue) => {
            if (queue.id === attendantQueue.id) arrayQueues.push(queue);
          });
        });

        setQueues(arrayQueues);
      })
      .catch((err) => {
        console.log('err', err);
      });

    TagClientService.getAll({ showDisabled: true }).then((response) => {
      const tagsResponse = response.data.data;

      if (tagsResponse && tagsResponse?.length) {
        const idToTagName = {};
        tagsResponse.forEach((tag) => {
          idToTagName[tag.id] = {
            name: tag.name,
            disabled: tag?.disabled,
            color: tag?.color
          };
        });

        setIdNameTags(idToTagName);
        setTags(tagsResponse);
      }
    });
  }, []);

  const getConversations = useCallback(() => {
    socketConversation.emit('conversas_do_atendente', {
      atendente_login: localStorage.getItem('login')
    });
  }, [socketConversation]);

  useEffect(() => {
    getConversations();
  }, [getConversations]);

  useEffect(() => {
    socketConversation.on('conversa_atendida', async (data) => {
      if (data.ja_atendida === undefined || data.ja_atendida === false) {
        await store.dispatch(addInitConversationInAttendance(data.conversa));
        getConversations();
      } else {
        getConversations();
      }
    });
  }, [socketConversation, getConversations]);

  useEffect(() => {
    socketChatTS.on('conversa_atendida', async (data) => {
      await store.dispatch(removeConversationInAttendance());
      await store.dispatch(addInitConversationInAttendance(data.conversa));
      await store.dispatch(addAnsweredConversation(data.conversa));
      await store.dispatch(
        removeUnAnsweredConversation(data.conversa._id ?? data.conversa.id)
      );

      setActiveTab(TABS.IN_ATTENDANCE);
    });
  }, [socketChatTS, getConversations]);

  useEffect(() => {
    socketChatTS.on(
      EVENTS_EMIT.UPDATE_CONFIG_SIGNAL_CONVERSATION,
      async (data) => {
        window.localStorage.setItem(
          'configSignalConversation',
          JSON.stringify(data)
        );

        allConversation.forEach((conversation) => {
          if (isInAttendance(conversation)) {
            handlerIndividualChatMetrics(conversation);
          }
        });
      }
    );
  }, [socketChatTS]);

  const answerConversation = async (
    conversation,
    id,
    transferMode,
    clientPhone,
    canal = ''
  ) => {
    if (transferMode === 'call') {
      if (telephonyServicePanel.extension === '') {
        toast.error(
          `Você precisa estar logado em um ramal para continuar este atendimento!`,
          {
            autoClose: 3000,
            closeOnClick: true
          }
        );
        return;
      }

      if (clientPhone === '') {
        toast.error(
          `Não é possível realizar a chamada pois não há telefone no cadastro do cliente!`,
          {
            autoClose: 3000,
            closeOnClick: true
          }
        );
        return;
      }

      if (
        !window.confirm(
          'Este cliente deseja um atendimento por ligação, tem certeza que deseja realizar a chamada agora?'
        )
      )
        return;

      const data = {
        origem: telephonyServicePanel.extension,
        destino: clientPhone
      };

      await apiChat.post(`/clicktocall`, data);
    }

    if (conversation?.situacao === ChatSituations.WAITING_IN_QUEUE) {
      return;
    }

    if (
      !conversation?.atendida &&
      conversation?.atendente?.id_postgres &&
      queuesChatLoggedValues?.length === 0
    ) {
      await store.dispatch(addInitConversationInAttendance(conversation));

      return;
    }

    if (
      inQueueChatPause &&
      currentQueueChatPause &&
      !currentQueueChatPause.active
    ) {
      await store.dispatch(addInitConversationInAttendance(conversation));
      return;
    }

    emitEventAnsweredChat({
      chatId: id,
      socketId: canal === 'facebook' ? socketConversation.id : socketChatTS.id
    });
  };

  const handlerFilter = (option, type) => {
    const filtersCopy = { ...filters };
    const typesBoolean = [
      'CHATS_SAVED',
      'INTERACTION_AGENT_WARNING',
      'INTERACTION_AGENT_CRITICAL',
      'INTERACTION_CLIENT',
      'CHATS_WITH_RESPONSE_AGENT'
    ];

    if (option === 'ALL') {
      filtersCopy[type] = [];
      setFilters(filtersCopy);
      return;
    }

    if (type === 'TIME') {
      filtersCopy[type] = option;
      setFilters(filtersCopy);
      return;
    }

    if (type === 'STATUS') {
      filtersCopy[type] = option;
      setFilters(filtersCopy);
      return;
    }

    if (type === 'START_TYPE') {
      if (option === filtersCopy[type]) {
        filtersCopy[type] = [];
        setFilters(filtersCopy);
        return;
      }
      filtersCopy[type] = option;
      setFilters(filtersCopy);
      return;
    }

    if (typesBoolean.includes(type)) {
      filtersCopy[type] = !filtersCopy[type];
      setFilters(filtersCopy);
      return;
    }

    const data = filtersCopy[type];
    if (!data) return;
    const index = data?.indexOf(option);
    if (index > -1) {
      data.splice(index, 1);
    } else {
      data.push(option);
    }
    filtersCopy[type] = queues;
    setFilters(filtersCopy);
  };

  const handlerSort = (type) => {
    const sortCopy = { ...sort };
    Object.keys(sortCopy).forEach((key) => {
      if (key === type) {
        sortCopy[key] = !sortCopy[type];
      }

      if (key !== type) {
        sortCopy[key] = false;
      }
    });

    setSort(sortCopy);
  };

  useEffect(() => {
    const isInAttendance = (chat) => {
      return (
        chat?.atendida &&
        chat?.atendente?.id_postgres === localStorage.getItem('login')
      );
    };

    const isAttributed = (chat) => {
      return (
        !chat?.atendida &&
        chat?.atendente?.id_postgres === localStorage.getItem('login')
      );
    };

    const isInWait = (chat) => {
      return !chat?.atendida && !chat?.atendente?.id_postgres;
    };

    const shouldFilter =
      filters['FILA'].length ||
      filters['TAG'].length ||
      filters['STATUS'].length ||
      filters['TIME'].length ||
      filters['START_TYPE'].length ||
      filters['CHATS_SAVED'] ||
      filters['INTERACTION_AGENT_WARNING'] ||
      filters['INTERACTION_AGENT_CRITICAL'] ||
      filters['INTERACTION_CLIENT'] ||
      filters['CHATS_WITH_RESPONSE_AGENT'];

    let chats = allConversation;

    const response = {
      IN_ATTENDANCE: [],
      ATTRIBUTED: [],
      IN_WAIT: []
    };

    chats.forEach((chat) => {
      if (isInAttendance(chat)) {
        response.IN_ATTENDANCE.unshift(chat);
      } else if (isAttributed(chat)) {
        response.ATTRIBUTED.unshift(chat);
      } else if (isInWait(chat)) {
        response.IN_WAIT.unshift(chat);
      }
    });

    const filterInternalConversation = (chats = []) => {
      let internalChats = chats;
      if (shouldFilter) {
        internalChats = chats?.filter((chat) => {
          return filterss(
            chat,
            filters,
            search,
            chatsSaved,
            chatsAgentWithoutInteractionCritical,
            chatsAgentWithoutInteractionWarning,
            chatsWithResponseAgent,
            chatsCustomerWithoutInteractionCritical
          );
        });
      }

      if (search && search !== '' && search?.length) {
        internalChats = internalChats.filter((chat) =>
          filterConversation(chat, search)
        );
      }
      return internalChats;
    };

    setChatsInAttendance(() => {
      const result = organizedConversations(
        filterInternalConversation(response.IN_ATTENDANCE)
      );
      setCountChatsInAttendance(result.length);
      return result;
    });

    setChatsAssigned(() => {
      const result = organizedConversations(
        filterInternalConversation(response.ATTRIBUTED)
      );
      setCountAttributedChats(result.length);
      return result;
    });

    setChatsInWait(() => {
      const result = organizedConversations(
        filterInternalConversation(response.IN_WAIT)
      );
      setCountChatsInWait(result.length);

      return result;
    });

    setAllChats(chats);
  }, [
    allConversation,
    search,
    filters,
    chatsSaved,
    sort,
    chatsSaved,
    chatsAgentWithoutInteractionCritical,
    chatsAgentWithoutInteractionWarning,
    chatsWithResponseAgent,
    chatsCustomerWithoutInteractionCritical
  ]);

  return (
    <Content primaryColor={systemConfiguration.primary_color}>
      <Header>
        <IndividualActiveContact
          getConversations={getConversations}
          selectedChats={selectedConversations}
          setSelectedChats={setSelectedConversations}
        />
        <SearchChat
          tags={tags}
          setSearch={setSearch}
          handlerFilter={handlerFilter}
          handlerSort={handlerSort}
        />
        <FilterBar handlerFilter={handlerFilter} />
        <TabChats
          activeTab={activeTab}
          setActiveTab={setActiveTab}
          countAttributedChats={countAttributedChats}
          countChatsInWait={countChatsInWait}
          countChatsInAttendance={countChatsInAttendance}
        />
      </Header>

      <TabContent activeTab={activeTab}>
        <TabChatsInWait
          queues={queues}
          idNameTags={idNameTags}
          chats={chatsInWait}
          answerConversation={answerConversation}
        />

        <TabAttributedChats
          queues={queues}
          idNameTags={idNameTags}
          chats={chatsAssigned}
          answerConversation={answerConversation}
        />

        <TabChatsInAttendance
          queues={queues}
          idNameTags={idNameTags}
          handleCheck={handleCheck}
          chats={chatsInAttendance}
          answerConversation={answerConversation}
          selectedConversations={selectedConversations}
        />
      </TabContent>
    </Content>
  );
};

export default QueueContent;
